import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'quesConsentFilter'
})
export class QuestionConsentFilterPipe implements PipeTransform {
    transform(questions: any[], selectedStep?: any): any[] {
        if (!questions) return [];

        return questions.filter(que => {
            // Basic null check
            if (!que) return false;

            // Show non-consent questions
            if (!que.isConsentQuestion) return true;

            // Show consent non-signature questions
            if (que.isConsentQuestion && que.inputType !== 'sign') return true;

            // Show consent signature questions only when step status is 'CP'
            // if (que.isConsentQuestion && que.inputType === 'sign' && selectedStep?.stepStatus === 'CP') {
            //     return true;
            // }

            return false;
        });
    }
}